import * as React from 'react';
export const Add = ({ width = 48, height = 48 }) => (React.createElement("svg", { width: width, height: height, viewBox: "0 0 48 48" },
    React.createElement("path", { d: "M26.5 22V.6h-4V22H1v4.1h21.4v21.3h4V26.1h21.3v-4z" })));
export default Add;
//# sourceMappingURL=Add.js.map